import { exposeFunction, exposeObject } from "@/utils/pages";

import AnalyticsManager, { type Analytics, type AnalyticsVendor } from "./v4_analytics";
import MatomoAnalytics from "./v4_matomo";
import SentryAnalytics from "./v4_sentry";
import SystemAnalytics from "./v4_system";
import IFrameAnalytics from "./v4_iframe";

AnalyticsManager.push(SystemAnalytics);
AnalyticsManager.push(MatomoAnalytics);
AnalyticsManager.push(SentryAnalytics);


for (let meta of Array.from(document.querySelectorAll("meta[name='analytics:iframe']"))) {
    const value: string = meta.getAttribute("value")!;

    AnalyticsManager.push({
        id: `custom:${value}`,
        strictlyRequired: false,
        inInitialActivations: false,
        build: ((a: Analytics) => (() => a))(new IFrameAnalytics(value)),
        describe: ((v: string) => async () => IFrameAnalytics.describe(v))(value)
    } as AnalyticsVendor);
}

AnalyticsManager.start().catch(window.reportError);
exposeObject("AnalyticsManager", AnalyticsManager);


export async function selectVendors() {
    const {default: CookieBanner} = await import("./V4CookieModal.svelte");
    const target = document.createElement("div");
    document.body.append(target);
    const banner = new CookieBanner({
        target
    });

    banner.$on("close", () => {
        banner.$destroy();
        target.remove();
    });
}

exposeFunction("select_cookie_vendors", async () => {
    await selectVendors();
});


const nobanner = !!document.querySelector("meta[name='analytics:no-banner'][value='true']");


if (!nobanner && !AnalyticsManager.isConfigured()) {
    (async () => {
        const {default: CookieBanner} = await import("./V4CookieBanner.svelte");
        const target = document.createElement("div");
        document.body.append(target);
        const banner = new CookieBanner({
            target
        });

        banner.$on("submit", () => {
            banner.$destroy();
            target.remove();
        });
    })().catch(window.reportError);
}
